<template>
    <div class="friend-link">
        <div class="friend-text">
            友情<br />
            链接
        </div>
        <ul>
            <li v-for="item in props.friendlyLinks">
                <a :href="item.linkUrl">{{ item.linkName }}</a>
            </li>
        </ul>
    </div>
</template>
<script setup>



const props = defineProps({
    friendlyLinks: {
        type: Array,
        default: () => ([])
    }
})



</script>
<style lang="scss" scoped>
.friend-link {
    max-width: 1166px;
    width: 100%;
    padding: 5px 0 5px 5px;
    border: 1px solid #eaeaea;
    margin: 0 auto;
    margin-top: 10px;
    box-sizing: border-box;
    background: linear-gradient(to bottom, #fff, #f3f8fe, #eaf4fe);
    display: flex;

    .friend-text {
        font-size: 16px;
        width: 52px;
        line-height: 26px;
        background-color: #0098d9;
        color: #fff;
        letter-spacing: 4px;
        text-align: center;
        padding: 8px;
        border-radius: 5px;
    }

    ul {
        // background-color: #f2f7fe;
        padding-left: 10px;

        li {
            display: inline-block;
            margin-right: 12px;
            margin-bottom: 12px;

            a {
                color: #9b9b9b;
                font-size: 12px;

                &:hover {
                    color: red;
                }
            }
        }
    }
}

/* 平板：宽度 ≤ 768px */
@media (max-width: 400px) {
    .friend-link {
        margin-bottom: 30px;

        .friend-text {
            width: 152px;
        }
    }
}
</style>